/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `stress_level` message.
 *
 * Value from 1 to 100 calculated by FirstBeat
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class StressLevelMesg : Mesg {
    public constructor() : super("StressLevel", Profile.MesgNum.STRESS_LEVEL)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** stress_level_value. */
    public var stressLevelValue: Short?
        get() = getFieldValue(STRESS_LEVEL_VALUE_FIELD_NUM) as? Short
        set(value) = setFieldValue(STRESS_LEVEL_VALUE_FIELD_NUM, value)

    /** stress_level_time, in s. Time stress score was calculated */
    public var stressLevelTime: Instant?
        get() = (getFieldValue(STRESS_LEVEL_TIME_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(STRESS_LEVEL_TIME_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    public companion object {
        public const val STRESS_LEVEL_VALUE_FIELD_NUM: UByte = 0u
        public const val STRESS_LEVEL_TIME_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("StressLevelValue", 0u, BaseType.SINT16, 1.0, 0.0, "", false)
            fields[1] = Field("StressLevelTime", 1u, BaseType.UINT32, 1.0, 0.0, "s", false)
            return fields
        }
    }
}
